import { Link, Outlet } from 'react-router-dom';

import { LogoMark } from '../common/LogoMark';
import pt from '../../locales/pt';
import { Button } from '../ui/Button';
import { ScrollToTop } from './ScrollToTop';

function BrandWordmark({ logoClassName = 'h-4 w-4', markClassName = 'h-8 w-8 rounded-ds-md' }) {
  return (
    <>
      <span
        className={`flex items-center justify-center bg-transparent text-sage-600 ${markClassName}`}
      >
        <LogoMark className={logoClassName} />
      </span>
      <span className="font-display font-bold tracking-tight text-foreground">
        <span className="text-sage-600">{pt.landing.brand.ev}</span>
        {pt.landing.brand.planner}
      </span>
    </>
  );
}

/**
 * Public Landing chrome — section/nav + section/footer (.pen).
 * Sticky nav with backdrop blur (motion context on nav frame).
 */
export function PublicLayout() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background">
      <ScrollToTop />
      <header className="sticky top-0 z-30 border-b border-border/60 bg-background/90 backdrop-blur-md">
        <div className="mx-auto flex h-14 w-full max-w-[1120px] items-center justify-between px-space-5 mid:px-space-10 wide:px-space-20">
          <Link to="/" className="flex items-center gap-space-2 text-lg">
            <BrandWordmark />
          </Link>
          <nav className="flex items-center gap-space-2 mid:gap-space-4">
            <Link
              to="/sign-in"
              className="px-space-2 type-body font-semibold text-muted-foreground hover:text-foreground"
            >
              {pt.landing.nav.login}
            </Link>
            <Link to="/sign-up" className="hidden sm:block">
              <Button size="sm" className="rounded-ds-full px-space-5">
                {pt.landing.nav.cta}
              </Button>
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-border bg-background">
        <div className="mx-auto flex w-full max-w-[1120px] flex-col items-center justify-between gap-space-4 px-space-5 py-space-10 type-body-sm text-muted-foreground mid:flex-row mid:px-space-10 wide:px-space-20">
          <Link to="/" className="flex items-center gap-space-2 text-sm">
            <BrandWordmark logoClassName="h-3.5 w-3.5" markClassName="h-5 w-5 rounded-ds-sm" />
          </Link>
          <nav className="flex flex-wrap items-center justify-center gap-space-3 mid:gap-space-4">
            <Link to="/faq" className="font-medium hover:text-foreground">
              {pt.landing.footer.faq}
            </Link>
            <Link to="/contact" className="font-medium hover:text-foreground">
              {pt.landing.footer.contact}
            </Link>
            <Link to="/privacy" className="font-medium hover:text-foreground">
              {pt.landing.footer.privacy}
            </Link>
            <Link to="/about" className="font-medium hover:text-foreground">
              {pt.landing.footer.about}
            </Link>
            <Link to="/terms" className="font-medium hover:text-foreground">
              {pt.landing.footer.terms}
            </Link>
          </nav>
          <span>{pt.landing.footer.copyright}</span>
        </div>
      </footer>
    </div>
  );
}
